import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInputClass;
function SavePlayerInput() {
  if (SavePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails) {
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.y73_1 = partyId;
        this.z73_1 = playerId;
        this.a74_1 = name;
        this.b74_1 = email;
        this.c74_1 = badge;
        this.d74_1 = callSignAdjective;
        this.e74_1 = callSignNoun;
        this.f74_1 = imageURL;
        this.g74_1 = avatarType;
        this.h74_1 = unvalidatedEmails;
      }
      toString() {
        return 'SavePlayerInput(partyId=' + this.y73_1.toString() + ', playerId=' + this.z73_1.toString() + ', name=' + this.a74_1 + ', email=' + this.b74_1 + ', badge=' + this.c74_1.toString() + ', callSignAdjective=' + this.d74_1 + ', callSignNoun=' + this.e74_1 + ', imageURL=' + toString(this.f74_1) + ', avatarType=' + toString(this.g74_1) + ', unvalidatedEmails=' + toString(this.h74_1) + ')';
      }
      hashCode() {
        var result = this.y73_1.hashCode();
        result = imul(result, 31) + this.z73_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.a74_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b74_1) | 0;
        result = imul(result, 31) + this.c74_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.d74_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e74_1) | 0;
        result = imul(result, 31) + hashCode(this.f74_1) | 0;
        result = imul(result, 31) + hashCode(this.g74_1) | 0;
        result = imul(result, 31) + hashCode(this.h74_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerInput()))
          return false;
        if (!this.y73_1.equals(other.y73_1))
          return false;
        if (!this.z73_1.equals(other.z73_1))
          return false;
        if (!(this.a74_1 === other.a74_1))
          return false;
        if (!(this.b74_1 === other.b74_1))
          return false;
        if (!this.c74_1.equals(other.c74_1))
          return false;
        if (!(this.d74_1 === other.d74_1))
          return false;
        if (!(this.e74_1 === other.e74_1))
          return false;
        if (!equals(this.f74_1, other.f74_1))
          return false;
        if (!equals(this.g74_1, other.g74_1))
          return false;
        if (!equals(this.h74_1, other.h74_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerInput');
    SavePlayerInputClass = $;
  }
  return SavePlayerInputClass;
}
//region block: exports
export {
  SavePlayerInput as SavePlayerInput3s7vno6nbe1ix,
};
//endregion

//# sourceMappingURL=SavePlayerInput.mjs.map
